import queryString from "query-string"

export const getQueryParams = (queryParams: Record<string, any>) => {
  return queryString.stringify(queryParams, {
    skipEmptyString: true,
    skipNull: true
  })
}
